import { defineNuxtPlugin } from '#app/nuxt'
import { LazyMenuPrincipal, LazyModifierMdp, LazySupprimerCompte, LazyListeFournisseurs, LazyRecupererVehicule, LazyStepperDepot, LazyCreateAccount, LazyDemandeResetPassword, LazyLoginByCredentials, LazyLoginByImmat, LazyLoginLight, LazyLoginStandard, LazyLogin, LazyPasswordRequirements, LazyResetPassword, LazyFiltreNotifications, LazyNotification, LazyListeProchainesVisites, LazySectionVisite, LazyCommentaireParPrestation, LazyMenuQueFaire, LazyPrestationQueFaire, LazySelecteurQueFaire, LazyAjouterReleveKilometrique, LazyHistoriqueReleve, LazyRendezVousActions, LazyRendezVousDetails, LazyRendezVousStepper, LazyRendezVous, LazyDocumentATelecharger, LazyMenuTelechargerDocument, LazyTransmettreDocument, LazyCarte, LazyFiltrePrestations, LazyNotationPrestataire, LazyPrestationIcone, LazyPrestation, LazyRecherchePrestataire, LazyResultatPrestataire, LazyResultatRechercheCarte, LazyResultatRechercheListe, LazyResultatsRecherchePrestataire, LazySlideTutoriel, LazyTutorielCarousel, LazyBoutonCarteAccreditive, LazyBoutonImmobilisation, LazyBoutonLivret, LazyBoutonProchaineVisite, LazyBouton, LazyCard, LazyCheckbox, LazyIcon, LazyTypeVehicule, LazyAdresseAutocomplete, LazyRating, LazySelecteur, LazyTextInput, LazyTextareaInput, LazyUploadDocument, LazyUploadPhoto, LazyMenu, LazyAjouterVehicule, LazyDemandeAjoutAppIos, LazyModaleGenerique, LazyModaleNouveauGarage, LazyPdfViewer, LazyScrollProgress, LazySwitch, LazyTitre, LazyToaster, LazyFicheVehicule, LazyInfosVehicule, LazyListeVehicules, LazyVehicule, LazyIconAccount, LazyIconAdd, LazyIconAddVehicule, LazyIconAppareilPhoto, LazyIconBook, LazyIconCalendar, LazyIconCarrosserie, LazyIconCarteAccreditive, LazyIconCheck, LazyIconCle, LazyIconCloche, LazyIconClose, LazyIconControleTechnique, LazyIconCritair1, LazyIconCritair2, LazyIconCritair3, LazyIconCritair4, LazyIconCritair5, LazyIconCritairelectrique, LazyIconCycl, LazyIconDocument, LazyIconDocumentsVehicule, LazyIconDownload, LazyIconError, LazyIconEstimationVehiculeVi, LazyIconEstimationVehiculeVl, LazyIconFilter, LazyIconFleche, LazyIconFournisseur, LazyIconGaragesPicto, LazyIconHome, LazyIconIllustration, LazyIconLeaf, LazyIconLogoCopilot, LazyIconLogoutFatec, LazyIconOeil, LazyIconPhone, LazyIconPin, LazyIconPinGarage, LazyIconPl, LazyIconPneus, LazyIconPointInterrogation, LazyIconReleveKm, LazyIconRem, LazyIconReparation, LazyIconReturn, LazyIconRevision, LazyIconStar, LazyIconSwitchVehicule, LazyIconTools, LazyIconTransmettreDocument, LazyIconTrashCan, LazyIconVehicule, LazyIconVitrage, LazyIconVl, LazyIconVp, LazyIconVul, LazyIconWarning } from '#components'
const lazyGlobalComponents = [
  ["MenuPrincipal", LazyMenuPrincipal],
["ModifierMdp", LazyModifierMdp],
["SupprimerCompte", LazySupprimerCompte],
["ListeFournisseurs", LazyListeFournisseurs],
["RecupererVehicule", LazyRecupererVehicule],
["StepperDepot", LazyStepperDepot],
["CreateAccount", LazyCreateAccount],
["DemandeResetPassword", LazyDemandeResetPassword],
["LoginByCredentials", LazyLoginByCredentials],
["LoginByImmat", LazyLoginByImmat],
["LoginLight", LazyLoginLight],
["LoginStandard", LazyLoginStandard],
["Login", LazyLogin],
["PasswordRequirements", LazyPasswordRequirements],
["ResetPassword", LazyResetPassword],
["FiltreNotifications", LazyFiltreNotifications],
["Notification", LazyNotification],
["ListeProchainesVisites", LazyListeProchainesVisites],
["SectionVisite", LazySectionVisite],
["CommentaireParPrestation", LazyCommentaireParPrestation],
["MenuQueFaire", LazyMenuQueFaire],
["PrestationQueFaire", LazyPrestationQueFaire],
["SelecteurQueFaire", LazySelecteurQueFaire],
["AjouterReleveKilometrique", LazyAjouterReleveKilometrique],
["HistoriqueReleve", LazyHistoriqueReleve],
["RendezVousActions", LazyRendezVousActions],
["RendezVousDetails", LazyRendezVousDetails],
["RendezVousStepper", LazyRendezVousStepper],
["RendezVous", LazyRendezVous],
["DocumentATelecharger", LazyDocumentATelecharger],
["MenuTelechargerDocument", LazyMenuTelechargerDocument],
["TransmettreDocument", LazyTransmettreDocument],
["Carte", LazyCarte],
["FiltrePrestations", LazyFiltrePrestations],
["NotationPrestataire", LazyNotationPrestataire],
["PrestationIcone", LazyPrestationIcone],
["Prestation", LazyPrestation],
["RecherchePrestataire", LazyRecherchePrestataire],
["ResultatPrestataire", LazyResultatPrestataire],
["ResultatRechercheCarte", LazyResultatRechercheCarte],
["ResultatRechercheListe", LazyResultatRechercheListe],
["ResultatsRecherchePrestataire", LazyResultatsRecherchePrestataire],
["SlideTutoriel", LazySlideTutoriel],
["TutorielCarousel", LazyTutorielCarousel],
["BoutonCarteAccreditive", LazyBoutonCarteAccreditive],
["BoutonImmobilisation", LazyBoutonImmobilisation],
["BoutonLivret", LazyBoutonLivret],
["BoutonProchaineVisite", LazyBoutonProchaineVisite],
["Bouton", LazyBouton],
["Card", LazyCard],
["Checkbox", LazyCheckbox],
["Icon", LazyIcon],
["TypeVehicule", LazyTypeVehicule],
["AdresseAutocomplete", LazyAdresseAutocomplete],
["Rating", LazyRating],
["Selecteur", LazySelecteur],
["TextInput", LazyTextInput],
["TextareaInput", LazyTextareaInput],
["UploadDocument", LazyUploadDocument],
["UploadPhoto", LazyUploadPhoto],
["Menu", LazyMenu],
["AjouterVehicule", LazyAjouterVehicule],
["DemandeAjoutAppIos", LazyDemandeAjoutAppIos],
["ModaleGenerique", LazyModaleGenerique],
["ModaleNouveauGarage", LazyModaleNouveauGarage],
["PdfViewer", LazyPdfViewer],
["ScrollProgress", LazyScrollProgress],
["Switch", LazySwitch],
["Titre", LazyTitre],
["Toaster", LazyToaster],
["FicheVehicule", LazyFicheVehicule],
["InfosVehicule", LazyInfosVehicule],
["ListeVehicules", LazyListeVehicules],
["Vehicule", LazyVehicule],
["IconAccount", LazyIconAccount],
["IconAdd", LazyIconAdd],
["IconAddVehicule", LazyIconAddVehicule],
["IconAppareilPhoto", LazyIconAppareilPhoto],
["IconBook", LazyIconBook],
["IconCalendar", LazyIconCalendar],
["IconCarrosserie", LazyIconCarrosserie],
["IconCarteAccreditive", LazyIconCarteAccreditive],
["IconCheck", LazyIconCheck],
["IconCle", LazyIconCle],
["IconCloche", LazyIconCloche],
["IconClose", LazyIconClose],
["IconControleTechnique", LazyIconControleTechnique],
["IconCritair1", LazyIconCritair1],
["IconCritair2", LazyIconCritair2],
["IconCritair3", LazyIconCritair3],
["IconCritair4", LazyIconCritair4],
["IconCritair5", LazyIconCritair5],
["IconCritairelectrique", LazyIconCritairelectrique],
["IconCycl", LazyIconCycl],
["IconDocument", LazyIconDocument],
["IconDocumentsVehicule", LazyIconDocumentsVehicule],
["IconDownload", LazyIconDownload],
["IconError", LazyIconError],
["IconEstimationVehiculeVi", LazyIconEstimationVehiculeVi],
["IconEstimationVehiculeVl", LazyIconEstimationVehiculeVl],
["IconFilter", LazyIconFilter],
["IconFleche", LazyIconFleche],
["IconFournisseur", LazyIconFournisseur],
["IconGaragesPicto", LazyIconGaragesPicto],
["IconHome", LazyIconHome],
["IconIllustration", LazyIconIllustration],
["IconLeaf", LazyIconLeaf],
["IconLogoCopilot", LazyIconLogoCopilot],
["IconLogoutFatec", LazyIconLogoutFatec],
["IconOeil", LazyIconOeil],
["IconPhone", LazyIconPhone],
["IconPin", LazyIconPin],
["IconPinGarage", LazyIconPinGarage],
["IconPl", LazyIconPl],
["IconPneus", LazyIconPneus],
["IconPointInterrogation", LazyIconPointInterrogation],
["IconReleveKm", LazyIconReleveKm],
["IconRem", LazyIconRem],
["IconReparation", LazyIconReparation],
["IconReturn", LazyIconReturn],
["IconRevision", LazyIconRevision],
["IconStar", LazyIconStar],
["IconSwitchVehicule", LazyIconSwitchVehicule],
["IconTools", LazyIconTools],
["IconTransmettreDocument", LazyIconTransmettreDocument],
["IconTrashCan", LazyIconTrashCan],
["IconVehicule", LazyIconVehicule],
["IconVitrage", LazyIconVitrage],
["IconVl", LazyIconVl],
["IconVp", LazyIconVp],
["IconVul", LazyIconVul],
["IconWarning", LazyIconWarning],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
